import { localStorageUtil } from '../../utils/local-storage.util';

export const scenarioShowHurdleStore = localStorageUtil<boolean>('isHurdleModalWasShown');
